import React from 'react';
import { BrowserRouter as Router, Routes, Route, Link } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import { Toaster } from 'react-hot-toast';
import { ScrollToTop } from './components/ScrollToTop';
import { Header } from './components/Header';
import { Footer } from './components/Footer';
import { Hero } from './components/Hero';
import { ServiceCard } from './components/ServiceCard';
import { ServicePage } from './pages/ServicePage';
import { ServicesPage } from './pages/ServicesPage';
import { CityPage } from './pages/CityPage';
import { SitemapPage } from './pages/SitemapPage';
import { ContactPage } from './pages/ContactPage';
import { LocationsPage } from './pages/LocationsPage';
import { BlogPost } from './pages/BlogPost';
import { SearchResultsPage } from './pages/SearchResultsPage';
import { PlumberRegistration } from './pages/PlumberRegistration';
import { AdminLayout } from './pages/admin/AdminLayout';
import { LoginPage } from './pages/admin/LoginPage';
import { ServiceManagement } from './pages/admin/ServiceManagement';
import { StateManagement } from './pages/admin/StateManagement';
import { SiteSettings } from './pages/admin/SiteSettings';
import { FAQManagement } from './pages/admin/FAQManagement';
import { Analytics } from './pages/admin/Analytics';
import { DataImport } from './pages/admin/DataImport';
import { PlumberManagement } from './pages/admin/PlumberManagement';
import { ArticleManagement } from './pages/admin/ArticleManagement';
import { services } from './data/services';

function HomePage() {
  return (
    <>
      <Hero />
      <section className="py-16 px-4 sm:px-6 lg:px-8">
        <div className="max-w-7xl mx-auto">
          <h2 className="text-3xl font-bold text-gray-900 text-center mb-12">
            Our Services
          </h2>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            {services.map((service) => (
              <Link 
                key={service.id || service.slug} 
                to={`/services/${service.slug}`}
                className="block"
              >
                <ServiceCard key={service.id || service.slug} service={service} />
              </Link>
            ))}
          </div>
        </div>
      </section>
    </>
  );
}

function App() {
  return (
    <HelmetProvider>
      <Router>
        <ScrollToTop />
        <div className="min-h-screen bg-gray-50 flex flex-col">
          <Routes>
            {/* Admin Routes */}
            <Route path="/admin/login" element={<LoginPage />} />
            <Route path="/admin" element={<AdminLayout />}>
              <Route index element={<PlumberManagement />} />
              <Route path="analytics" element={<Analytics />} />
              <Route path="plumbers" element={<PlumberManagement />} />
              <Route path="services" element={<ServiceManagement />} />
              <Route path="states" element={<StateManagement />} />
              <Route path="settings" element={<SiteSettings />} />
              <Route path="faqs" element={<FAQManagement />} />
              <Route path="articles" element={<ArticleManagement />} />
              <Route path="import" element={<DataImport />} />
            </Route>

            {/* Public Routes */}
            <Route
              path="*"
              element={
                <>
                  <Header />
                  <main className="flex-grow">
                    <Routes>
                      <Route path="/" element={<HomePage />} />
                      <Route path="/services" element={<ServicesPage />} />
                      <Route path="/services/:id" element={<ServicePage />} />
                      <Route path="/:citySlug/:stateCode" element={<CityPage />} />
                      <Route path="/:stateCode/:citySlug/:zipCode" element={<SearchResultsPage />} />
                      <Route path="/blog/:slug" element={<BlogPost />} />
                      <Route path="/locations" element={<LocationsPage />} />
                      <Route path="/sitemap" element={<SitemapPage />} />
                      <Route path="/contact" element={<ContactPage />} />
                      <Route path="/register" element={<PlumberRegistration />} />
                    </Routes>
                  </main>
                  <Footer />
                </>
              }
            />
          </Routes>
          <Toaster position="top-right" />
        </div>
      </Router>
    </HelmetProvider>
  );
}

export default App;